<template>
    <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-12">
            <div class="preset_bar">
                <div class="preset_bar__field">
                    <i class="icon icon-chevron-down"></i>
                    <i class="preset_bar__icon mdi mdi-clock-outline"></i>
                    <daterange-presets v-model="query.daterange"/>
                </div>
                <div class="preset_bar__field">
                    <i class="icon icon-chevron-down"></i>
                    <i class="preset_bar__icon mdi mdi-map-marker-outline"></i>
                    <country-filter v-model="query.country_id"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model} from 'vue-property-decorator';
    import DaterangePresets from './presetbar/DaterangePresets';
    import CountryFilter from './presetbar/CountryFilter';

    @Component({
        components: {
            DaterangePresets,
            CountryFilter,
        }
    })
    export default class PresetBar extends Vue {
        @Model({
            type: Object,
            default: () => ({
                begin: null,
                end: null,
            })
        })
        query;
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/PresetBar.vue